export const formatNumber = (number) => {
  // Check if the input is a valid number
  if (isNaN(Number(number))) {
    return number; // Return the input unchanged if not a valid number
  }

  // Convert the number to a string and format with commas
  return Number(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatDate = (timestamp) => {
  if (!timestamp) return "";

  const isSeconds = timestamp.toString().length === 10;
  const date = new Date(isSeconds ? timestamp * 1000 : timestamp);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

